import Header from '../../../Shared-Component/Header/Header';
import Footer from '../../../Shared-Component/Footer/Footer';
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle';
import { useState } from 'react';
import swayam from "../../../assets/CampuLifeImages/swayam.jpg"
import "../SWAYAM/Swayam.scss"
import "../../CampusSharedComponent/CampusDynamicPages/CampusSkillEnhanceDynamicPage/CampusSkillEnhance.scss"






const Swayam = () => {
        const [showContent, setShowContent] = useState(false)


    const handleShowContent = () => {
        setShowContent(!showContent)
    }

    return (
        <>
            <div>
                <Header />
                <div className='campusmaincontainer'>
                <div className='campus-container'>
                    <CampusSlashTitle slashTitle="SWAYAM / NPTEL / MOOC" />
                    <div className='skill-content-container'>
                        <p>
                            Noorul Islam College of Arts & Science actively participates in the National Programme on Technology Enhanced Learning (NPTEL), a joint initiative by the Indian Institutes of Technology (IITs) and the Indian Institute of Science (IISc). By incorporating NPTEL's extensive online courses and certifications into its academic offerings, NICAS provides students with access to high-quality content across various disciplines. This collaboration enriches the learning experience, supports skill development, and underscores the institution's dedication to continuous improvement and academic excellence.
                        </p>
                        <div className='swayam-objectives-container'>
                            <h2>Objectives of NPTEL :</h2>
                            <p>
                                <span><b>Curriculum Enhancement : </b>

                                </span>
                                NPTEL provides a vast repository of online courses across various disciplines, enabling colleges to supplement and enrich their existing curricula with up-to-date content.
                            </p>
                            <p>
                                <span><b>Faculty Development : </b>

                                </span>
                                Through NPTEL, educators can access specialized training and resources, fostering continuous professional growth and the adoption of innovative teaching methodologies.
                            </p>
                            <p>
                                <span><b> Student Skill Development : </b>
                                </span>
                                Students benefit from NPTEL's diverse courses, gaining knowledge and certifications that enhance their competencies and prepare them for industry challenges.
                            </p>
                            <p>
                                <span><b>Collaborative Opportunities : </b>

                                </span>
                                Engaging with NPTEL opens avenues for collaboration with premier institutions like the IITs and IISc, promoting knowledge exchange and academic partnerships.
                            </p>
                        </div>

                        <p>
                            <span><b> SPOC : </b>
                            </span>
                            Mrs. T. D. Jeba Freeda, Asst. Professor, Dept. of Computer Science.
                        </p>
                            <div className='swayam-image-container'>
                                <img src={swayam} alt='swayam'></img>
                                <p>NPTEL Certificate awarded Students (JAN - APR 2025)</p>
                            </div>
                    </div>
                    </div>
                    <Footer />
                </div>
            </div>

        </>

    )
}

export default Swayam


